
import Brush3 from "../../../assets/duotone/Brush3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Brush3Icon({ className, dataTestid = "Brush3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Brush3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
